
// SVG Icon: decrease
export default { id: "terriajs-decrease" };
export const id = "terriajs-decrease";
export const name = "decrease";
